

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"name":"English","code":"en","iso":"en-US","file":"en.js","flag":"us"},{"name":"Russian","code":"ru","iso":"ru","file":"ru.js","flag":"ru"},{"name":"Bulgarian","code":"bg","iso":"bg","file":"bg.js","flag":"bg"},{"name":"Hebrew","code":"he","iso":"he","file":"he.js","dir":"rtl","flag":"il"},{"name":"Dutch","code":"nl","iso":"nl","file":"nl.js","flag":"nl"},{"name":"Spanish","code":"es","iso":"es","file":"es.js","flag":"es"},{"name":"Arabic","code":"ar","iso":"ar","file":"ar.js","dir":"rtl","flag":"ae"},{"name":"Hungarian","code":"hu","iso":"hu","file":"hu.js","flag":"hu"},{"name":"Korean","code":"ko","iso":"ko","file":"ko.js","flag":"kr"},{"name":"Urdu","code":"ur","iso":"ur","file":"ur.js","dir":"rtl","flag":"pk"},{"name":"French","code":"fr","iso":"fr","file":"fr.js","flag":"fr"},{"name":"Hindi","code":"hi","iso":"hi","file":"hi.js","flag":"in"},{"name":"Romanian","code":"ro","iso":"ro","file":"ro.js","flag":"ro"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/usr/src/app/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://thrivestate.io",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  loadLanguagesAsync: true,
  SEO: false,
  normalizedLocales: [{"name":"English","code":"en","iso":"en-US","file":"en.js","flag":"us"},{"name":"Russian","code":"ru","iso":"ru","file":"ru.js","flag":"ru"},{"name":"Bulgarian","code":"bg","iso":"bg","file":"bg.js","flag":"bg"},{"name":"Hebrew","code":"he","iso":"he","file":"he.js","dir":"rtl","flag":"il"},{"name":"Dutch","code":"nl","iso":"nl","file":"nl.js","flag":"nl"},{"name":"Spanish","code":"es","iso":"es","file":"es.js","flag":"es"},{"name":"Arabic","code":"ar","iso":"ar","file":"ar.js","dir":"rtl","flag":"ae"},{"name":"Hungarian","code":"hu","iso":"hu","file":"hu.js","flag":"hu"},{"name":"Korean","code":"ko","iso":"ko","file":"ko.js","flag":"kr"},{"name":"Urdu","code":"ur","iso":"ur","file":"ur.js","dir":"rtl","flag":"pk"},{"name":"French","code":"fr","iso":"fr","file":"fr.js","flag":"fr"},{"name":"Hindi","code":"hi","iso":"hi","file":"hi.js","flag":"in"},{"name":"Romanian","code":"ro","iso":"ro","file":"ro.js","flag":"ro"}],
  localeCodes: ["en","ru","bg","he","nl","es","ar","hu","ko","ur","fr","hi","ro"],
  additionalMessages: [],
}

export const localeMessages = {
  'en.js': () => import('../../locales/en.js' /* webpackChunkName: "lang-en.js" */),
  'ru.js': () => import('../../locales/ru.js' /* webpackChunkName: "lang-ru.js" */),
  'bg.js': () => import('../../locales/bg.js' /* webpackChunkName: "lang-bg.js" */),
  'he.js': () => import('../../locales/he.js' /* webpackChunkName: "lang-he.js" */),
  'nl.js': () => import('../../locales/nl.js' /* webpackChunkName: "lang-nl.js" */),
  'es.js': () => import('../../locales/es.js' /* webpackChunkName: "lang-es.js" */),
  'ar.js': () => import('../../locales/ar.js' /* webpackChunkName: "lang-ar.js" */),
  'hu.js': () => import('../../locales/hu.js' /* webpackChunkName: "lang-hu.js" */),
  'ko.js': () => import('../../locales/ko.js' /* webpackChunkName: "lang-ko.js" */),
  'ur.js': () => import('../../locales/ur.js' /* webpackChunkName: "lang-ur.js" */),
  'fr.js': () => import('../../locales/fr.js' /* webpackChunkName: "lang-fr.js" */),
  'hi.js': () => import('../../locales/hi.js' /* webpackChunkName: "lang-hi.js" */),
  'ro.js': () => import('../../locales/ro.js' /* webpackChunkName: "lang-ro.js" */),
}
